export default __webpack_public_path__ + "static/media/Back_Titanium.14f51af7.png";